// Bilingual translations: Kannada (kn) + English (en)
// Kannada is the default language.

export const translations = {
  kn: {
    brand: {
      name: 'ಜೈ ಭೀಮ್ ಸೇವಾ ಸಂಘ',
      tagline: 'ಸೇವೆಯೇ ಎಲ್ಲವೂ. ಎಲ್ಲವೂ.',
      registered: '(ರಿ)',
      regNo: 'ನೋಂ.ಸಂ. DRB3/SOR/153/2026-27',
    },
    nav: {
      home: 'ಮುಖಪುಟ',
      about: 'ನಮ್ಮ ಬಗ್ಗೆ',
      objectives: 'ಉದ್ದೇಶಗಳು',
      programs: 'ಕಾರ್ಯಕ್ರಮಗಳು',
      council: 'ಆಡಳಿತ ಮಂಡಳಿ',
      gallery: 'ಗ್ಯಾಲರಿ',
      contact: 'ಸಂಪರ್ಕ',
      donate: 'ದಾನ ಮಾಡಿ',
      admin: 'ನಿರ್ವಾಹಕ',
    },
    common: {
      volunteer: 'ಸದಸ್ಯರಾಗಿ',
      learnMore: 'ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ',
      viewAll: 'ಎಲ್ಲವನ್ನೂ ನೋಡಿ',
      backHome: 'ಮುಖಪುಟಕ್ಕೆ ಹಿಂತಿರುಗಿ',
      switchLang: 'EN',
      comingSoon: 'ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿದೆ...',
      comingSoonMsg: 'ಈ ವೈಶಿಷ್ಟ್ಯ ಶೀಘ್ರದಲ್ಲೇ ಲಭ್ಯವಾಗಲಿದೆ. ದಯವಿಟ್ಟು ನಂತರ ಪರಿಶೀಲಿಸಿ.',
    },
    donation: {
      title: 'ಜೈ ಭೀಮ್ ಸೇವಾ ಸಂಘಕ್ಕೆ ದಾನ ಮಾಡಿ',
      subtitle: 'ನಿಮ್ಮ ಕೊಡುಗೆ ಶಿಕ್ಷಣ, ಸಂಘಟನೆ ಮತ್ತು ಸಮುದಾಯ ಸೇವೆಗೆ ಬೆಂಬಲ ನೀಡುತ್ತದೆ.',
      chooseAmount: 'ಮೊತ್ತವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
      customAmount: 'ಅಥವಾ ಬೇರೆ ಮೊತ್ತ ನಮೂದಿಸಿ (₹)',
      name: 'ಹೆಸರು',
      phone: 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ',
      pay: 'ದಾನ ಮಾಡಿ',
      secure: 'Razorpay ಮೂಲಕ ಸುರಕ್ಷಿತ ಪಾವತಿ · UPI, ಕಾರ್ಡ್, ನೆಟ್‌ಬ್ಯಾಂಕಿಂಗ್',
      messageNote: 'ರಶೀದಿ ಲಿಂಕ್‌ನೊಂದಿಗೆ ಧನ್ಯವಾದ ಸಂದೇಶವನ್ನು ನಿಮ್ಮ WhatsApp / SMS ಗೆ ಕಳುಹಿಸಲಾಗುತ್ತದೆ.',
      successTitle: 'ಧನ್ಯವಾದಗಳು!',
      successMsg: 'ನಿಮ್ಮ ದಾನ ಯಶಸ್ವಿಯಾಗಿ ಸ್ವೀಕರಿಸಲಾಗಿದೆ.',
      receiptNo: 'ರಶೀದಿ ಸಂಖ್ಯೆ',
      amount: 'ಮೊತ್ತ',
      download: 'ರಶೀದಿ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ',
      close: 'ಮುಚ್ಚಿ',
      failed: 'ಪಾವತಿ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
      cancelled: 'ಪಾವತಿ ಪೂರ್ಣಗೊಂಡಿಲ್ಲ. ನೀವು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಬಹುದು.',
      invalidAmount: 'ದಯವಿಟ್ಟು ₹1 ರಿಂದ ₹5,00,000 ರ ನಡುವಿನ ಮೊತ್ತ ನಮೂದಿಸಿ.',
      invalidName: 'ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹೆಸರನ್ನು ನಮೂದಿಸಿ.',
      invalidPhone: 'ದಯವಿಟ್ಟು ಮಾನ್ಯವಾದ 10 ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ.',
      wallConsent: 'ಧನ್ಯವಾದ ಗೋಡೆಯಲ್ಲಿ ನನ್ನ ಮೊದಲ ಹೆಸರು ಮತ್ತು ಊರನ್ನು ತೋರಿಸಿ (ಮೊತ್ತ ತೋರಿಸುವುದಿಲ್ಲ)',
      place: 'ನಿಮ್ಮ ಊರು (ಐಚ್ಛಿಕ)',
    },
    wall: {
      title: 'ನಮ್ಮ ದಾನಿಗಳಿಗೆ ಧನ್ಯವಾದಗಳು',
      subtitle: 'ಇತ್ತೀಚೆಗೆ ನಮ್ಮ ಕಾರ್ಯಕ್ಕೆ ಬೆಂಬಲ ನೀಡಿದ ಆತ್ಮೀಯರು.',
    },
    membership: {
      title: 'ಸದಸ್ಯರಾಗಿ',
      subtitle: 'ಜೈ ಭೀಮ್ ಸೇವಾ ಸಂಘಕ್ಕೆ ಸೇರಲು ಅರ್ಜಿ ಸಲ್ಲಿಸಿ. ನಮ್ಮ ತಂಡ ಪರಿಶೀಲಿಸಿ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತದೆ.',
      name: 'ಹೆಸರು',
      place: 'ವಾಸಸ್ಥಳ',
      occupation: 'ಉದ್ಯೋಗ',
      additional: 'ಹೆಚ್ಚುವರಿ ಮಾಹಿತಿ',
      submit: 'ಅರ್ಜಿ ಸಲ್ಲಿಸಿ',
      successTitle: 'ಅರ್ಜಿ ಸ್ವೀಕರಿಸಲಾಗಿದೆ!',
      successMsg: 'ಧನ್ಯವಾದಗಳು. ನಿಮ್ಮ ಅರ್ಜಿ ಪರಿಶೀಲನೆಯಲ್ಲಿದೆ.',
      required: 'ದಯವಿಟ್ಟು ಹೆಸರು ಮತ್ತು ವಾಸಸ್ಥಳವನ್ನು ನಮೂದಿಸಿ.',
      duplicate: 'ಈ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯ ಅರ್ಜಿ ಈಗಾಗಲೇ ಪರಿಶೀಲನೆಯಲ್ಲಿದೆ.',
      failed: 'ಅರ್ಜಿ ಸಲ್ಲಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
      photo: 'ಭಾವಚಿತ್ರ (ಐಚ್ಛಿಕ)',
      photoHint: 'ಗುರುತಿನ ಚೀಟಿಗಾಗಿ ಪಾಸ್‌ಪೋರ್ಟ್ ಗಾತ್ರದ ಫೋಟೋ ಸೇರಿಸಿ (ಗರಿಷ್ಠ 5MB).',
      uploading: 'ಅಪ್‌ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
      photoRemove: 'ತೆಗೆದುಹಾಕಿ',
      photoTooLarge: 'ಫೋಟೋ ತುಂಬಾ ದೊಡ್ಡದಾಗಿದೆ (ಗರಿಷ್ಠ 5MB).',
      photoFailed: 'ಫೋಟೋ ಅಪ್‌ಲೋಡ್ ವಿಫಲವಾಗಿದೆ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
    },
    hero: {
      location: 'ಬೆಂಗಳೂರು, ಭಾರತ',
      title: 'ಸಮಾನತೆ, ಶಿಕ್ಷಣ ಮತ್ತು ಸೇವೆಯ ಮೂಲಕ ಬಲಗೈ ಜಾತಿ ಸಮುದಾಯಗಳ ಸಬಲೀಕರಣ.',
      subtitle:
        'ಘನತೆ, ಅವಕಾಶ ಮತ್ತು ಸಾಮಾಜಿಕ ನ್ಯಾಯದ ತಳಹದಿಯ ಮೇಲೆ ಭವಿಷ್ಯವನ್ನು ಕಟ್ಟಲು ನಾವು ಹಿಂದುಳಿದ ಸಮುದಾಯಗಳೊಂದಿಗೆ ಕೆಲಸ ಮಾಡುತ್ತೇವೆ.',
    },
    about: {
      eyebrow: 'ಸಮಾನ ನಾಳೆಗಾಗಿ ಒಂದು ಚಳುವಳಿ',
      title: 'ಕರುಣೆ ಮತ್ತು ಸಮುದಾಯ ಸೇವೆ ಸಂಗಮವಾಗುವ ತಾಣ.',
      body:
        'ಜೈ ಭೀಮ್ ಸೇವಾ ಸಂಘವು ಕರ್ನಾಟಕದಾದ್ಯಂತ ಶಿಕ್ಷಣ, ಮಹಿಳಾ ಮತ್ತು ಮಕ್ಕಳ ಕಲ್ಯಾಣ, ಯುವ ನಾಯಕತ್ವ, ಗ್ರಾಮೀಣಾಭಿವೃದ್ಧಿ ಮತ್ತು ಆರೋಗ್ಯ ಸೇವೆಯ ಲಭ್ಯತೆಯನ್ನು ಮುಂದುವರೆಸಲು ಬದ್ಧವಾಗಿರುವ ಸಮುದಾಯ-ನೇತೃತ್ವದ ಲಾಭರಹಿತ ಸಂಸ್ಥೆಯಾಗಿದೆ. ಡಾ. ಬಿ. ಆರ್. ಅಂಬೇಡ್ಕರ್ ಅವರ ಮೌಲ್ಯಗಳಿಂದ ಪ್ರೇರಿತಗೊಂಡು, ನಾವು ಸಮಾನತೆ, ಘನತೆ ಮತ್ತು ತಳಮಟ್ಟದ ಸೇವೆಗಾಗಿ ನಿಲ್ಲುತ್ತೇವೆ.',
    },
    objectives: {
      eyebrow: 'ನಾವು ನಂಬುವ ಮೌಲ್ಯಗಳು',
      title: 'ನಮ್ಮ ಉದ್ದೇಶಗಳು',
      subtitle:
        'ನಾವು ಕೈಗೊಳ್ಳುವ ಪ್ರತಿಯೊಂದು ಕಾರ್ಯಕ್ರಮ, ಪಾಲುದಾರಿಕೆ ಮತ್ತು ಸೇವೆಯನ್ನು ಮಾರ್ಗದರ್ಶಿಸುವ ಸ್ಪಷ್ಟ ಬದ್ಧತೆಗಳ ಗುಂಪು.',
      items: {
        education: {
          title: 'ಶಿಕ್ಷಣ ಮತ್ತು ಕಲಿಕೆಯ ಪ್ರೋತ್ಸಾಹ',
          desc: 'ಪ್ರತಿಯೊಬ್ಬ ಮಗು ಮತ್ತು ವಯಸ್ಕರಿಗೂ ಗುಣಮಟ್ಟದ ಶಿಕ್ಷಣ ಮತ್ತು ಜೀವನಪರ್ಯಂತ ಕಲಿಕೆಯ ಅವಕಾಶಗಳನ್ನು ವಿಸ್ತರಿಸಿ.',
        },
        welfare: {
          title: 'ಮಹಿಳಾ ಮತ್ತು ಮಕ್ಕಳ ಕಲ್ಯಾಣ',
          desc: 'ಸಮುದಾಯಗಳಾದ್ಯಂತ ಮಹಿಳೆಯರು ಮತ್ತು ಮಕ್ಕಳ ಸುರಕ್ಷತೆ, ಆರೋಗ್ಯ, ಘನತೆ ಮತ್ತು ಹಕ್ಕುಗಳಿಗಾಗಿ ಹೋರಾಡಿ.',
        },
        youth: {
          title: 'ಯುವ ಸಬಲೀಕರಣ',
          desc: 'ನಾಯಕತ್ವ, ಮಾರ್ಗದರ್ಶನ ಮತ್ತು ನಾಗರಿಕ ಪಾಲ್ಗೊಳ್ಳುವಿಕೆಯ ಕಾರ್ಯಕ್ರಮಗಳೊಂದಿಗೆ ಮುಂದಿನ ಪೀಳಿಗೆಯನ್ನು ಪೋಷಿಸಿ.',
        },
        rural: {
          title: 'ಗ್ರಾಮೀಣಾಭಿವೃದ್ಧಿ',
          desc: 'ಜೀವನೋಪಾಯ, ಮೂಲಸೌಕರ್ಯ ಮತ್ತು ನೀರಿನ ಸೌಲಭ್ಯದ ಮೂಲಕ ಗ್ರಾಮೀಣ ಪ್ರದೇಶಗಳಲ್ಲಿ ಸಮರ್ಥನೀಯ ಬೆಳವಣಿಗೆ ಸಾಧಿಸಿ.',
        },
        health: {
          title: 'ಆರೋಗ್ಯ ಜಾಗೃತಿ',
          desc: 'ತಡೆಗಟ್ಟುವ ಮತ್ತು ಪ್ರಾಥಮಿಕ ಆರೋಗ್ಯ ಸೇವೆಯನ್ನು ಉತ್ತೇಜಿಸುವ ಆರೋಗ್ಯ ಶಿಬಿರಗಳು ಮತ್ತು ಜಾಗೃತಿ ಅಭಿಯಾನಗಳನ್ನು ನಡೆಸಿ.',
        },
        scholarship: {
          title: 'ವಿದ್ಯಾರ್ಥಿವೇತನ ಮತ್ತು ಶಿಕ್ಷಣ ಬೆಂಬಲ',
          desc: 'ಅರ್ಹ ಮತ್ತು ಅಗತ್ಯವಿರುವ ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ವಿದ್ಯಾರ್ಥಿವೇತನ, ಪಠ್ಯಸಾಮಗ್ರಿ ಮತ್ತು ಬೋಧನೆ ಒದಗಿಸಿ.',
        },
        community: {
          title: 'ಸಮುದಾಯ ಅಭಿವೃದ್ಧಿ',
          desc: 'ಸಮಗ್ರ, ತಳಮಟ್ಟದ ಅಭಿವೃದ್ಧಿ ಉಪಕ್ರಮಗಳ ಮೂಲಕ ಸ್ಥಳೀಯ ಸಮುದಾಯಗಳನ್ನು ಬಲಪಡಿಸಿ.',
        },
        justice: {
          title: 'ಸಾಮಾಜಿಕ ನ್ಯಾಯ ಮತ್ತು ಸಮಾನತೆ',
          desc: 'ಹಿಂದುಳಿದ ಮತ್ತು ಅಂಚಿನಲ್ಲಿರುವವರಿಗಾಗಿ ಸಮಾನತೆ, ಘನತೆ ಮತ್ತು ಸಾಮಾಜಿಕ ನ್ಯಾಯವನ್ನು ಎತ್ತಿಹಿಡಿಯಿರಿ.',
        },
        skill: {
          title: 'ಕೌಶಲ್ಯ ಅಭಿವೃದ್ಧಿ',
          desc: 'ಯುವಕರು ಮತ್ತು ಮಹಿಳೆಯರಿಗೆ ಜೀವನೋಪಾಯಕ್ಕಾಗಿ ವೃತ್ತಿಪರ, ಡಿಜಿಟಲ್ ಮತ್ತು ಉದ್ಯಮಶೀಲ ಕೌಶಲ್ಯಗಳನ್ನು ನೀಡಿ.',
        },
        partnership: {
          title: 'ಸರ್ಕಾರ ಮತ್ತು ಎನ್‌ಜಿಒಗಳೊಂದಿಗೆ ಪಾಲುದಾರಿಕೆ',
          desc: 'ಪ್ರಭಾವ ಮತ್ತು ವ್ಯಾಪ್ತಿಯನ್ನು ಹೆಚ್ಚಿಸಲು ಸರ್ಕಾರಿ ಸಂಸ್ಥೆಗಳು ಮತ್ತು ಪಾಲುದಾರ ಎನ್‌ಜಿಒಗಳೊಂದಿಗೆ ಸಹಯೋಗಿಸಿ.',
        },
      },
    },
    programs: {
      eyebrow: 'ನಾವು ಏನು ಮಾಡುತ್ತೇವೆ',
      title: 'ನಮ್ಮ ಕಾರ್ಯಕ್ರಮಗಳು',
      subtitle: 'ನಾವು ಸೇವೆ ಸಲ್ಲಿಸುವ ಸಮುದಾಯಗಳ ಅತ್ಯಂತ ಒತ್ತಡದ ಅಗತ್ಯಗಳನ್ನು ಪರಿಹರಿಸುವ ಏಳು ಕೇಂದ್ರೀಕೃತ ಕಾರ್ಯಕ್ರಮಗಳು.',
      items: {
        education: {
          title: 'ಶಿಕ್ಷಣ ಬೆಂಬಲ',
          desc: 'ಪ್ರಥಮ ತಲೆಮಾರಿನ ಕಲಿಯುಗಾರರಿಗೆ ಶಾಲೆಯ ನಂತರದ ಕಲಿಕಾ ಕೇಂದ್ರಗಳು, ವಿದ್ಯಾರ್ಥಿವೇತನ, ಸಾಮಗ್ರಿಗಳು ಮತ್ತು ಬೋಧನೆ.',
        },
        women: {
          title: 'ಮಹಿಳಾ ಸಬಲೀಕರಣ',
          desc: 'ಮಹಿಳೆಯರಿಗಾಗಿ ವೃತ್ತಿಪರ ತರಬೇತಿ, ಸ್ವಸಹಾಯ ಗುಂಪುಗಳು, ಕಾನೂನು ಜಾಗೃತಿ ಮತ್ತು ಉದ್ಯಮಶೀಲತೆ ಬೆಂಬಲ.',
        },
        child: {
          title: 'ಮಕ್ಕಳ ಕಲ್ಯಾಣ',
          desc: 'ಅಸುರಕ್ಷಿತ ಮಕ್ಕಳಿಗಾಗಿ ಪೋಷಣೆ, ಸುರಕ್ಷಿತ ಸ್ಥಳಗಳು, ಮಕ್ಕಳ ಹಕ್ಕು ಪ್ರತಿಪಾದನೆ ಮತ್ತು ಶಿಕ್ಷಣ.',
        },
        youth: {
          title: 'ಯುವ ಅಭಿವೃದ್ಧಿ',
          desc: 'ಯುವ ವಯಸ್ಕರಿಗಾಗಿ ನಾಯಕತ್ವ ಕಾರ್ಯಾಗಾರಗಳು, ವೃತ್ತಿ ಮಾರ್ಗದರ್ಶನ, ನಾಗರಿಕ ಪಾಲ್ಗೊಳ್ಳುವಿಕೆ ಮತ್ತು ಕೌಶಲ್ಯ ತರಬೇತಿ.',
        },
        rural: {
          title: 'ಗ್ರಾಮೀಣಾಭಿವೃದ್ಧಿ',
          desc: 'ಗ್ರಾಮೀಣ ಕರ್ನಾಟಕದಲ್ಲಿ ನೈರ್ಮಲ್ಯ, ನೀರಿನ ಲಭ್ಯತೆ, ಜೀವನೋಪಾಯ ಕಾರ್ಯಕ್ರಮಗಳು ಮತ್ತು ಮೂಲಸೌಕರ್ಯ ಬೆಂಬಲ.',
        },
        health: {
          title: 'ಆರೋಗ್ಯ ಜಾಗೃತಿ',
          desc: 'ಉಚಿತ ಆರೋಗ್ಯ ಶಿಬಿರಗಳು, ಜಾಗೃತಿ ಅಭಿಯಾನಗಳು, ಮಾತೃತ್ವ ಆರೈಕೆ ಮತ್ತು ರೋಗ ತಡೆಗಟ್ಟುವ ಶಿಕ್ಷಣ.',
        },
        community: {
          title: 'ಸಮುದಾಯ ಸೇವೆ',
          desc: 'ವಿಪತ್ತು ಪರಿಹಾರ, ಆಹಾರ ವಿತರಣೆ, ಹಬ್ಬದ ಪ್ರಚಾರ ಮತ್ತು ಸ್ಥಳೀಯ ನೆಲದ ಬೆಂಬಲ.',
        },
      },
    },
    cta: {
      eyebrow: 'ಬದಲಾವಣೆಯ ಭಾಗವಾಗಿ',
      title: 'ಸೇವೆಯ ಪ್ರತಿಯೊಂದು ಸಣ್ಣ ಕ್ರಿಯೆಯೂ ರೂಪಾಂತರಕ್ಕೆ ಸಂಗ್ರಹವಾಗುತ್ತದೆ. ನಿಮ್ಮ ಸಮಯವನ್ನು ನೀಡಿ, ನಿಮ್ಮ ಕೌಶಲ್ಯಗಳನ್ನು ಹಂಚಿಕೊಳ್ಳಿ ಅಥವಾ ನಮ್ಮ ಕೆಲಸವನ್ನು ಬೆಂಬಲಿಸಿ.',
    },
    footer: {
      about: 'ಕರ್ನಾಟಕದಾದ್ಯಂತ ಸಮಾನತೆ, ಶಿಕ್ಷಣ ಮತ್ತು ಸಮುದಾಯ ಸೇವೆಗೆ ಬದ್ಧವಾಗಿರುವ ಲಾಭರಹಿತ ಸಂಸ್ಥೆ.',
      quickLinks: 'ತ್ವರಿತ ಲಿಂಕ್‌ಗಳು',
      contact: 'ಸಂಪರ್ಕ',
      address: 'ಎಚ್‌ಎಸ್‌ಆರ್ ಲೇಔಟ್, ಬೆಂಗಳೂರು, ಕರ್ನಾಟಕ, ಭಾರತ',
      copyright: '© 2026 ಜೈ ಭೀಮ್ ಸೇವಾ ಸಂಘ. ಎಲ್ಲ ಹಕ್ಕುಗಳು ಕಾಯ್ದಿರಿಸಿವೆ.',
      tagline: 'ಸಮುದಾಯದ ಪ್ರಭಾವಕ್ಕಾಗಿ ಎಚ್ಚರಿಕೆಯಿಂದ ನಿರ್ಮಿಸಲಾಗಿದೆ.',
      admin: 'ನಿರ್ವಾಹಕ',
    },
    council: {
      eyebrow: 'ಜೈ ಭೀಮ್ ಸೇವಾ ಸಂಘದಲ್ಲಿ ನಾಯಕತ್ವ',
      title: 'ಆಡಳಿತ ಮಂಡಳಿ',
      subtitle:
        'ಕರ್ನಾಟಕದಾದ್ಯಂತ ಸಮಾನತೆ, ಶಿಕ್ಷಣ ಮತ್ತು ತಳಮಟ್ಟದ ಸೇವೆಯ ನಮ್ಮ ಧ್ಯೇಯವನ್ನು ಮಾರ್ಗದರ್ಶಿಸುವ ನಾಯಕರನ್ನು ಭೇಟಿ ಮಾಡಿ.',
      member: 'ಸದಸ್ಯ',
      selectLevel: 'ಹಂತವನ್ನು ಆರಿಸಿ',
      levels: {
        state: 'ರಾಜ್ಯ ಮಟ್ಟ',
        district: 'ಜಿಲ್ಲಾ ಮಟ್ಟ',
        taluk: 'ತಾಲೂಕು ಮಟ್ಟ',
        gram_panchayat: 'ಗ್ರಾಮ ಪಂಚಾಯತ್ ಮಟ್ಟ',
        general: 'ಸಾಮಾನ್ಯ ಸದಸ್ಯರು',
      },
      membersHeading: '{level} ಸದಸ್ಯರು',
      viewDetails: 'ವಿವರಗಳನ್ನು ನೋಡಿ',
      searchPlaceholder: 'ಹೆಸರಿನಿಂದ ಸದಸ್ಯರನ್ನು ಹುಡುಕಿ...',
      noResults: 'ಯಾವುದೇ ಸದಸ್ಯರು ಕಂಡುಬಂದಿಲ್ಲ.',
      loading: 'ಸದಸ್ಯರನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...',
      contactNumberLabel: 'ಸಂಪರ್ಕ ಸಂಖ್ಯೆ',
      locationLabel: 'ಸ್ಥಳ',
      emailLabel: 'ಇಮೇಲ್',
      placeOfStayLabel: 'ವಾಸಸ್ಥಳ',
      photoPlaceholder: 'ಛಾಯಾಚಿತ್ರ ಸ್ಥಳಧಾರಕ',
      nameTemplate: '[ಸದಸ್ಯ {n} ಪೂರ್ಣ ಹೆಸರು]',
      designation: '[ಪದನಾಮ]',
      intro: '[ಸದಸ್ಯರ ಬಗ್ಗೆ ಸಣ್ಣ ಪರಿಚಯ ಇಲ್ಲಿ ಬರುತ್ತದೆ. ಇದು ಸ್ಥಳಧಾರಕವಾಗಿದೆ.]',
      introLabel: 'ಪರಿಚಯ',
      achievementsLabel: 'ಸಾಧನೆಗಳು',
      achievements: '[ಮುಖ್ಯ ಸಾಧನೆಗಳ ಸ್ಥಳಧಾರಕ]',
      qualificationsLabel: 'ಅರ್ಹತೆಗಳು',
      qualifications: '[ಅರ್ಹತೆಗಳ ಸ್ಥಳಧಾರಕ]',
      awardsLabel: 'ಪ್ರಶಸ್ತಿಗಳು ಮತ್ತು ಮಾನ್ಯತೆ',
      awards: '[ಪ್ರಶಸ್ತಿ ಮತ್ತು ಮಾನ್ಯತೆ ಸ್ಥಳಧಾರಕ]',
      contributionsLabel: 'ಕೊಡುಗೆಗಳು',
      contributions: '[ಸಂಸ್ಥೆಗೆ ಕೊಡುಗೆಗಳ ಸ್ಥಳಧಾರಕ]',
      contactMember: 'ಸದಸ್ಯರನ್ನು ಸಂಪರ್ಕಿಸಿ',
    },
  },

  en: {
    brand: {
      name: 'JAI BHEEM SEVA SANGHA',
      tagline: 'SERVICE IS EVERYTHING. EVERYTHING.',
      registered: '(R)',
      regNo: 'Reg.No. DRB3/SOR/153/2026-27',
    },
    nav: {
      home: 'Home',
      about: 'About Us',
      objectives: 'Objectives',
      programs: 'Programs',
      council: 'Governing Council',
      gallery: 'Gallery',
      contact: 'Contact',
      donate: 'Donate',
      admin: 'Admin',
    },
    common: {
      volunteer: 'Become a Member',
      learnMore: 'Learn More',
      viewAll: 'View all',
      backHome: 'Back to Home',
      switchLang: 'ಕನ್ನಡ',
      comingSoon: 'Coming Soon...',
      comingSoonMsg: 'This feature is coming soon. Please check back later.',
    },
    donation: {
      title: 'Donate to Jai Bheem Seva Sangha',
      subtitle: 'Your contribution supports education, organization and community service.',
      chooseAmount: 'Choose an amount',
      customAmount: 'Or enter another amount (₹)',
      name: 'Name',
      phone: 'Mobile number',
      pay: 'Donate',
      secure: 'Secure payment via Razorpay · UPI, Cards, Netbanking',
      messageNote: 'A thank-you message with your receipt link will be sent to your WhatsApp / SMS.',
      successTitle: 'Thank you!',
      successMsg: 'Your donation has been received successfully.',
      receiptNo: 'Receipt No',
      amount: 'Amount',
      download: 'Download Receipt',
      close: 'Close',
      failed: 'Payment failed. Please try again.',
      cancelled: 'Payment was not completed. You can try again.',
      invalidAmount: 'Please enter an amount between ₹1 and ₹5,00,000.',
      invalidName: 'Please enter your name.',
      invalidPhone: 'Please enter a valid 10-digit mobile number.',
      wallConsent: 'Show my first name and place on the thank-you wall (amount is never shown)',
      place: 'Your place (optional)',
    },
    wall: {
      title: 'Thank You to Our Donors',
      subtitle: 'Friends who recently supported our work.',
    },
    membership: {
      title: 'Become a Member',
      subtitle: 'Apply to join Jai Bheem Seva Sangha. Our team will review and get in touch.',
      name: 'Name',
      place: 'Place of Residence',
      occupation: 'Occupation',
      additional: 'Additional Information',
      submit: 'Submit Application',
      successTitle: 'Application received!',
      successMsg: 'Thank you. Your application is under review.',
      required: 'Please enter your name and place of residence.',
      duplicate: 'An application with this mobile number is already under review.',
      failed: 'Could not submit the application. Please try again.',
      photo: 'Photo (optional)',
      photoHint: 'Add a passport-size photo for your ID card (max 5MB).',
      uploading: 'Uploading...',
      photoRemove: 'Remove',
      photoTooLarge: 'Photo is too large (max 5MB).',
      photoFailed: 'Photo upload failed. Please try again.',
    },
    hero: {
      location: 'BENGALURU, INDIA',
      title: 'Empowering Right Hand Castes Communities Through Equality, Education, and Service.',
      subtitle:
        'We work alongside the underserved to build a future rooted in dignity, opportunity, and social justice.',
    },
    about: {
      eyebrow: 'A MOVEMENT FOR AN EQUAL TOMORROW',
      title: 'Where compassion meets community action.',
      body:
        'JAI BHEEM SEVA SANGHA is a community-led non-profit dedicated to advancing education, women & child welfare, youth leadership, rural development and healthcare access across Karnataka. Inspired by the values of Dr. B. R. Ambedkar, we stand for equality, dignity and grassroots service.',
    },
    objectives: {
      eyebrow: 'WHAT WE STAND FOR',
      title: 'Our Objectives',
      subtitle:
        'A clear set of commitments that guide every program, partnership and act of service we undertake.',
      items: {
        education: {
          title: 'Promoting Education & Learning',
          desc: 'Expand access to quality education and lifelong learning opportunities for every child and adult.',
        },
        welfare: {
          title: 'Women & Child Welfare',
          desc: 'Champion the safety, health, dignity and rights of women and children across communities.',
        },
        youth: {
          title: 'Youth Empowerment',
          desc: 'Nurture the next generation with leadership, mentorship and civic engagement programs.',
        },
        rural: {
          title: 'Rural Development',
          desc: 'Drive sustainable growth in rural areas through livelihood, infrastructure and water access.',
        },
        health: {
          title: 'Healthcare Awareness',
          desc: 'Run health camps and awareness drives that promote preventive and primary healthcare.',
        },
        scholarship: {
          title: 'Scholarships & Educational Support',
          desc: 'Provide scholarships, study materials and tutoring to deserving students in need.',
        },
        community: {
          title: 'Community Development',
          desc: 'Strengthen local communities through inclusive, grassroots-led development initiatives.',
        },
        justice: {
          title: 'Social Justice & Equality',
          desc: 'Uphold equality, dignity and social justice for the underserved and marginalised.',
        },
        skill: {
          title: 'Skill Development',
          desc: 'Equip youth and women with vocational, digital and entrepreneurial skills for livelihoods.',
        },
        partnership: {
          title: 'Partnerships with Government & NGOs',
          desc: 'Collaborate with government bodies and partner NGOs to scale impact and reach.',
        },
      },
    },
    programs: {
      eyebrow: 'WHAT WE DO',
      title: 'Our Programs',
      subtitle: 'Seven focused programs that address the most pressing needs of the communities we serve.',
      items: {
        education: {
          title: 'Education Support',
          desc: 'After-school learning centres, scholarships, supplies and tutoring for first-generation learners.',
        },
        women: {
          title: 'Women Empowerment',
          desc: 'Vocational training, self-help groups, legal awareness and entrepreneurship support for women.',
        },
        child: {
          title: 'Child Welfare',
          desc: 'Nutrition, safe spaces, child rights advocacy and education for vulnerable children.',
        },
        youth: {
          title: 'Youth Development',
          desc: 'Leadership workshops, career mentoring, civic engagement and skills training for young adults.',
        },
        rural: {
          title: 'Rural Development',
          desc: 'Sanitation, water access, livelihood programs and infrastructure support in rural Karnataka.',
        },
        health: {
          title: 'Healthcare Awareness',
          desc: 'Free health camps, awareness drives, maternal care and disease prevention education.',
        },
        community: {
          title: 'Community Service',
          desc: 'Disaster relief, food distribution, festival outreach and on-ground support where it matters.',
        },
      },
    },
    cta: {
      eyebrow: 'BE PART OF THE CHANGE',
      title:
        'Every small act of service compounds into transformation. Volunteer your time, share your skills, or support our work.',
    },
    footer: {
      about: 'A non-profit committed to equality, education and community service across Karnataka.',
      quickLinks: 'QUICK LINKS',
      contact: 'CONTACT',
      address: 'HSR Layout, Bengaluru, Karnataka, India',
      copyright: '© 2026 JAI BHEEM SEVA SANGHA. All rights reserved.',
      tagline: 'Built with care for community impact.',
      admin: 'Admin',
    },
    council: {
      eyebrow: 'LEADERSHIP in JBSS',
      title: 'Governing Council',
      subtitle:
        'Meet the leaders who guide our mission of equality, education and grassroots service across Karnataka.',
      member: 'Member',
      selectLevel: 'Select Level',
      levels: {
        state: 'State Level',
        district: 'District Level',
        taluk: 'Taluk Level',
        gram_panchayat: 'Gram Panchayat Level',
        general: 'General Members',
      },
      membersHeading: '{level} Members',
      viewDetails: 'View Details',
      searchPlaceholder: 'Search members by name...',
      noResults: 'No members found.',
      loading: 'Loading members...',
      contactNumberLabel: 'Contact Number',
      locationLabel: 'Location',
      emailLabel: 'Email',
      placeOfStayLabel: 'Place of Stay',
      photoPlaceholder: 'Photograph Placeholder',
      nameTemplate: '[Full Name of Member {n}]',
      designation: '[Designation]',
      intro: '[Short introduction about the member goes here. This is a placeholder.]',
      introLabel: 'Introduction',
      achievementsLabel: 'Achievements',
      achievements: '[Key achievements placeholder]',
      qualificationsLabel: 'Qualifications',
      qualifications: '[Qualifications placeholder]',
      awardsLabel: 'Awards & Recognition',
      awards: '[Awards & recognition placeholder]',
      contributionsLabel: 'Contributions',
      contributions: '[Contributions to the organization placeholder]',
      contactMember: 'Contact Member',
    },
  },
};

export const DEFAULT_LANG = 'kn';
export const SUPPORTED = ['kn', 'en'];
